import Requester from '../Requester';

const createDeliveryOrder = (data, userPhone) => {
    return Requester.makeRequest(Requester.methods.POST, "customers/" + userPhone + "/deliveries", "", data)
};

const getDeliveryDetailsById = (userPhone, deliveryId) => {
    return Requester.makeRequest(Requester.methods.GET, "customers/" + userPhone + "/delivery/" + deliveryId);
};

const getDeliveries = (userPhone) => {
    return Requester.makeRequest(Requester.GET, "customers/" + userPhone + "/deliveries")
};


const getDeliveryHistory = (userPhone) => {
    return Requester.makeRequest(Requester.GET, "customers/" + userPhone + "/deliveries/history")
};


export default {
    createDeliveryOrder: createDeliveryOrder,
    getDeliveryDetailsById: getDeliveryDetailsById,
    getDeliveryHistory: getDeliveryHistory,
    getDeliveries: getDeliveries
}

